$(document).ready(function(){
  $('.main-product-slider').slick({
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 981,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".image-with-carousel-gallery .carousel-list").slick({
    slidesToScroll: 3,
    slidesToShow: 3,
    autoplay: false,
    nextArrow: '<div class="slick-arrow slick-arrow-right"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icon-tabler-chevron-right"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l6 6l-6 6" /></svg></div>',
    prevArrow: '<div class="slick-arrow slick-arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icon-tabler-chevron-left"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 6l-6 6l6 6" /></svg></div>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  function initPhotoSwipeLightbox($container) {
    if (!$container || !window.mainImages) return;

    var lightbox = new PhotoSwipeLightbox({
      dataSource: window.mainImages,
      pswpModule: PhotoSwipe,
      showHideAnimationType: 'zoom',
      bgOpacity: 1,
      arrowPrevSVG: '<svg class="pswp__icn" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',
      arrowNextSVG: '<svg class="pswp__icn" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',
      closeSVG: '<svg class="pswp__icn" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
    });

    lightbox.addFilter('thumbEl', function (thumbEl, data, index) {
      return thumbEl;
    });

    lightbox.addFilter('placeholderSrc', function (placeholderSrc, slide) {
      return placeholderSrc;
    });

    var videoPlugin = window.PhotoSwipeVideoPlugin;

    lightbox.init();

    $container.data('lightboxInstance', lightbox);

    $container.find('.mImgLightbox-trigger').each(function (index, el) {
      $(el).on('click', function (e) {
        e.preventDefault();
        lightbox.loadAndOpen(index);
      });
    });

    return lightbox;
  }


    function destroyPhotoSwipeLightbox($container) {
      var lightbox = $container.data('lightboxInstance');
      if (lightbox) {
        lightbox.destroy();
        $container.removeData('lightboxInstance');
      }
    };

    if($('.main-product-slider').length){
      initPhotoSwipeLightbox($('.main-product-slider'), window.mainImages);
    }

});